<app-menu #appMenu></app-menu>

<div class="kit-details-page">
    @if (isLoading == true) {
    <div class="container">
        <div class="product-details">
            <div class="product-details__left">
                <div class="product-main-info">
                    <div class="product-image">
                        <app-loading-box [height]="'300'" [width]="'100%'" [marginTop]="'0'"></app-loading-box>
                    </div>
                    <div class="product-info">
                        <app-loading-box [height]="'30'" [width]="'300'" [marginTop]="'0'"></app-loading-box>
                        <app-loading-box [height]="'15'" [width]="'229'" [marginTop]="'25'"></app-loading-box>
                        <app-loading-box [height]="'15'" [width]="'129'" [marginTop]="'7'"></app-loading-box>
                        <app-loading-box [height]="'15'" [width]="'189'" [marginTop]="'7'"></app-loading-box>
                        <app-loading-box [height]="'15'" [width]="'289'" [marginTop]="'7'"></app-loading-box>
                    </div>
                </div>
            </div>
            <div class="product-details__right">
                <div class="product-purchase">
                    <div class="product-purchase__price"><app-loading-box [height]="'15'" [width]="'330'"
                            [marginTop]="'7'"></app-loading-box></div>
                    <div class="product-purchase__shipping">
                        <app-loading-box [height]="'15'" [width]="'330'" [marginTop]="'7'"></app-loading-box>
                        <app-loading-box [height]="'15'" [width]="'330'" [marginTop]="'7'"></app-loading-box>
                        <div class="cep-calculator">
                            <app-loading-box [height]="'15'" [width]="'130'" [marginTop]="'7'"></app-loading-box>
                            <app-loading-box [height]="'15'" [width]="'130'" [marginTop]="'7'"></app-loading-box>
                        </div>
                    </div>

                    <div class="product-purchase__actions">
                        <app-loading-box [height]="'30'" [width]="'210'" [marginTop]="'7'"></app-loading-box>
                        <app-loading-box [height]="'30'" [width]="'210'" [marginTop]="'7'"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @else if(kitDetails){
    <div class="container">
        <div class="product-details">
            <div class="product-details__left">
                <div class="product-main-info">
                    <div class="product-image">
                        <img [src]="kitDetails.bookCoverURL" [alt]="kitDetails.bookTitle"
                            onerror="this.onerror=null;this.src='https://placehold.co/400x600/e0e0e0/333?text=Capa+Indisponível';">
                    </div>
                    <div class="product-info">
                        <h1 class="product-title">{{ kitDetails.bookTitle }}</h1>
                        <div class="book-tags">
                            @if (kitDetails.includesEbook) {
                            <span class="tag ebook">Ebook</span>
                            }
                            @if (kitDetails.includesBook) {
                            <span class="tag fisico">Físico</span>
                            }
                            @if (kitDetails.includesVideoAccess) {
                            <span class="tag video">Videos</span>
                            }
                        </div>

                        <p class="product-description">{{kitDetails.synopsis}}</p>
                    </div>
                </div>

                @if(kitDetails.rating && kitDetails.rating.totalRatings > 0){
                <div class="ratings-section-wrapper">
                    <h3>Avaliações</h3>
                    <div class="product-ratings">
                        <div class="product-ratings__left">
                            <div class="average-rating">{{ kitDetails.rating.averageRating.toFixed(1) }}</div>
                            <div class="average-stars">
                                @for(star of [1,2,3,4,5]; track star){
                                <mat-icon [class.filled]="star <= kitDetails.rating.averageRating">star</mat-icon>
                                }
                            </div>
                            <div class="total-reviews">{{ kitDetails.rating.totalRatings }} reviews</div>
                        </div>
                        <div class="product-ratings__right">
                            <div class="rating-distribution-bars">
                                @for(star of [5,4,3,2,1]; track star){
                                <div class="rating-bar">
                                    <span class="rating-bar__label">{{star}}</span>
                                    <div class="rating-bar__progress">
                                        <div class="progress-fill" [style.width.%]="getRatingPercentage(star)"></div>
                                    </div>
                                    <span class="rating-bar__percentage">{{ getRatingPercentage(star).toFixed(0)
                                        }}%</span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                }

                <div class="author-info-section">
                    <h3>Sobre {{kitDetails.authorName}}</h3>
                    <div class="author-info row">
                        <div class="col-sm-4 text-center">
                            <img [src]="kitDetails.authorPhotoURL" [alt]="kitDetails.authorName"
                                [ngClass]="{'author-photo-roung': kitDetails.idPhotoShape == 2}" class="author-photo"
                                onerror="this.onerror=null;this.src='https://placehold.co/80x80/e0e0e0/333?text=Foto';">
                        </div>
                        <div class="col-sm-8">
                            <p>{{ kitDetails.authorBio }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-details-info">
                    <h3>Detalhes do Produto</h3>
                    <ul>
                        <li><span>Editora:</span> <span>Editora Diálogo Freiriano</span></li>
                        <li><span>Idioma:</span> <span>Português</span></li>
                        <li><span>Edição:</span> <span>{{kitDetails.versionName}}</span></li>
                        <li><span>Páginas:</span> <span>{{kitDetails.estimatedPages}}</span></li>
                        <li><span>Data de Publicação:</span> <span>{{ kitDetails.publicationDate | date:'longDate'
                                }}</span></li>
                        <li><span>Dimensões:</span> <span>{{kitDetails.dimensions}}</span></li>
                        <li><span>ISBN:</span> <span>{{kitDetails.isbn}}</span></li>
                        <li><span>Categoria:</span> <span>{{kitDetails.primaryCategoryName}}</span></li>
                    </ul>
                </div>

                @if(kitDetails.videoChapters && kitDetails.videoChapters.length > 0){
                <div class="extra-content-section">
                    <h2>Aulas extras do livro</h2>
                    <div class="carousel-wrapper">
                        <button mat-icon-button class="carousel-button prev" (click)="scrollLeft()">
                            <mat-icon>arrow_back_ios</mat-icon>
                        </button>
                        <div class="carousel-container" #carouselContainer>
                            <div class="extra-content-grid">
                                @for(video of kitDetails.videoChapters; track video.chapterName){
                                <div class="extra-content-card">
                                    <div class="extra-content-thumbnail">
                                        <img [src]="video.imageURL" [alt]="video.chapterName"
                                            onerror="this.onerror=null;this.src='https://placehold.co/300x170/e0e0e0/333?text=Aula';">
                                        <mat-icon class="play-icon">play_circle</mat-icon>
                                    </div>
                                    <h3>{{video.chapterName}}</h3>
                                    <p>{{video.description}}</p>
                                </div>
                                }
                            </div>
                        </div>
                        <button mat-icon-button class="carousel-button next" (click)="scrollRight()">
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>
                    </div>
                </div>
                }

                @if(kitDetails.otherKits && kitDetails.otherKits.length > 0){
                <div class="related-products-section">
                    <h2>Quem compra {{ kitDetails.bookTitle }} também compra</h2>
                    <div class="related-products-grid">
                        @for(other of kitDetails.otherKits; track other.idKit){
                        <div class="related-product-card">
                            <img [src]="other.imageUrl" [alt]="other.kitName"
                                onerror="this.onerror=null;this.src='https://placehold.co/300x200/e0e0e0/333?text=Kit';">
                            <h3>{{other.kitName}}</h3>
                            <div class="book-tags small">
                                @if (other.includesEbook) {
                                <span class="tag ebook">Ebook</span>
                                }
                                @if (other.includesBook) {
                                <span class="tag fisico">Físico</span>
                                }
                                @if (other.includesVideoAccess) {
                                <span class="tag video">Videos</span>
                                }
                            </div>
                            <span class="related-product-price">{{other.price | currency:'BRL':'symbol':'1.2-2'}}</span>
                            <button mat-flat-button class="add-to-cart-related" type="button"
                                (click)="addCartClick(other.idKit)">Adicionar ao carrinho</button>
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
            <div class="product-details__right">
                <div class="product-purchase">
                    <div class="product-purchase__price">{{ kitDetails.kitPrice | currency:'BRL':'symbol':'1.2-2' }}
                    </div>
                    <div class="product-purchase__shipping">
                        <mat-icon>local_shipping</mat-icon>
                        Entrega para
                        <span><span class="shipping-address">{{address}}</span></span>
                        <div class="cep-calculator">
                            <mat-form-field appearance="outline" class="cep-input">
                                <mat-label>Calcular frete e prazo</mat-label>
                                <input matInput [(ngModel)]="cep" mask="00000-000" placeholder="00000-000">
                            </mat-form-field>
                            <button mat-stroked-button color="primary" (click)="calculateShipping()"
                                [disabled]="isLoadingShipping">
                                @if(isLoadingShipping){
                                <mat-spinner [diameter]="20"></mat-spinner>
                                } @else {
                                Calcular
                                }
                            </button>
                        </div>
                        @if (kitDetailsCorreiosEstimateResponse &&
                        kitDetailsCorreiosEstimateResponse.listCorreiosEstimates) {
                        <ul class="shipping-results">
                            @for(shipping of kitDetailsCorreiosEstimateResponse.listCorreiosEstimates; track
                            shipping.price){
                            <li>
                                <span>{{shipping.serviceName}}</span>
                                <span>{{shipping.price | currency:'BRL'}}</span>
                                <small>Chegará em até {{shipping.estimadeDays}} dias úteis</small>
                            </li>
                            }
                        </ul>
                        }
                    </div>
                    <div class="product-purchase__quantity">
                        <label for="quantity">Quantidade:</label>
                        <div class="quantity-selector">
                            <button type="button" (click)="decrementQuantity()">-</button>
                            <input type="number" id="quantity" [value]="quantity" min="1" readonly>
                            <button type="button" (click)="incrementQuantity()">+</button>
                        </div>
                    </div>
                    <div class="product-purchase__actions">
                        <button mat-flat-button class="add-to-cart" (click)="addCartClick(this.idKit)">Adicionar ao
                            Carrinho</button>
                        <button mat-stroked-button class="buy-now" (click)="clickToBuy()">Comprar Agora</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>

@if(kitDetails){
<div class="mobile-fixed-footer">
    <div class="footer-price-container">
        <span class="price-mobile">{{ kitDetails.kitPrice | currency:'BRL':'symbol':'1.2-2' }}</span>
    </div>
    <div class="footer-buttons-container">
        <button mat-stroked-button class="add-to-cart-btn-mobile" (click)="addCartClick(this.idKit)">Adicionar ao
            Carrinho</button>
        <button mat-flat-button class="buy-now-btn-mobile" (click)="clickToBuy()">Comprar Agora</button>
    </div>
</div>
}

<app-footer></app-footer>